module.exports = __webpack_public_path__ + "img/v1_ny_tree.1bdb498a.svg";